import React from 'react';
import { SelectableChip } from '../../pages/brand/BrandDashboard/CreateCampaignStyles';

/** Shared word cap for profile bio / company description fields. */
export const PROFILE_BIO_MAX_WORDS = 100;

/** Shortest bio or brand description accepted in onboarding. */
export const PROFILE_BIO_MIN_WORDS = 5;

/** Scrollable chip picker container shared by profile category/preference lists. */
export const profileChipScrollSx = {
  maxHeight: 'min(380px, 52vh)',
  overflowY: 'auto',
  overflowX: 'hidden',
  pr: 0.5,
  mb: 1,
};

export function countWords(text) {
  if (!text || !String(text).trim()) return 0;
  return String(text).trim().split(/\s+/).length;
}

export function trimToMaxWords(text, maxWords = PROFILE_BIO_MAX_WORDS) {
  if (!text || !String(text).trim()) return '';
  const words = String(text).trim().split(/\s+/);
  if (words.length <= maxWords) return text;
  return words.slice(0, maxWords).join(' ');
}

/** Selectable pill used in profile category / preference / fee-model pickers. */
export function PreferenceChip({ label, selected, onToggle }) {
  return (
    <SelectableChip
      selected={selected}
      role="button"
      tabIndex={0}
      aria-pressed={selected}
      aria-label={`${label}, ${selected ? 'selected' : 'not selected'}`}
      onClick={onToggle}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          onToggle();
        }
      }}
    >
      {label}
    </SelectableChip>
  );
}
